/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createAtan } from '../../factoriesAny.js';
export var atanDependencies = {
  typedDependencies: typedDependencies,
  createAtan: createAtan
};